import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatDatepickerInputEvent,
  MatDialog,
  MatSnackBar,
  PageEvent,
} from "@angular/material";
import { HealthOrganizationStatus } from "src/app/core/models/healthOrganizationStatus";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { NotificationService } from "src/app/shared/notification-center/notification.service";
import { UserAssignComponent } from "./user-assign/user-assign.component";
import { HealthSystemService } from "src/app/core/services/v2/health-system.service";
import { ViewModalComponent } from "./view-file/view-file.component";
import { HEALTH_ORGANIZATION_TYPES } from "src/app/core/constants/constants.model";

@Component({
  selector: "app-health-organization-status",
  templateUrl: "./health-organization-status.component.html",
  styleUrls: ["./health-organization-status.component.scss"],
})
export class HealthOrganizationStatusComponent implements OnInit {
  @ViewChild(UserAssignComponent, { static: false })
  childComponent: UserAssignComponent;
  healthOrganizationList = HEALTH_ORGANIZATION_TYPES;

  selectedHealthOrgId: number;
  pageSize = 10;
  page = 1;
  totalRecordsActive = 0;
  totalRecordsPending = 0;
  totalRecordsTrial = 0;
  totalRecordsInactive = 0;
  displayedPendingColumns: string[] = [
    "OrganizationName",
    "HealthOrganizationType",
    "PrimaryContact",
    "Phone",
    "Email",
    "Address",
    "Website",
    "Action"
  ];
  displayedColumnsActive: string[] = [
    "name",
    "HealthOrganizationType",
    "healthSystemCount",
    "usersCount",
    "oneTimeSetupFeePaid",
    // "setupCompleted",
    "lastTransactionAmount",
    "lastTransactionDate",
    // "endOfTrial",
    "inActive",
    // "view",
    // "file",
    "doc",
    // "user",
  ];

  displayedColumnsTrial: string[] = [
    "name",
    "HealthOrganizationType",
    "healthSystemCount",
    "usersCount",
    "oneTimeSetupFeePaid",
    // "setupCompleted",
    // "lastTransactionDate",
    // "lastTransactionAmount",
    "endOfTrial",
    "inActive",
    // "view",
    // "file",
    "doc",
    // "user",
  ];

  displayedColumnsInactive: string[] = [
    "name",
    "HealthOrganizationType",
    "healthSystemCount",
    "usersCount",
    "oneTimeSetupFeePaid",
    // "setupCompleted",
    // "lastTransactionDate",
    // "lastTransactionAmount",
    // "endOfTrial",
    // "inActive",
    // "view",
    // "file",
    // "doc",
    // "user",
  ];
  // hosActive: Array<any>[] = [];
  filteredHosActive: Array<any>[] = [];
  // hosPending: HealthOrganizationStatus[];
  filteredHosPending: Array<any>[] = [];
  hosPending: Array<any>[] = [];
  // hosTrial: HealthOrganizationStatus[];
  filteredHosTrial: Array<any>[] = [];
  // hosInActive: HealthOrganizationStatus[];
  filteredHosInActive: Array<any>[] = [];
  isChecked = true;
  selectedTab: string;

  constructor(
    private practiceService: PracticeService,
    private loaderService: WindowLoaderService,
    private notificationService: NotificationService,
    private _matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public healthSystemService: HealthSystemService
  ) { }

  toggleSidebar = false;
  sideBarHeader = "Administrators";
  ngOnInit() {
    this.LoadHosActiveStatus();
    this.LoadHosInactiveStatus();
    this.LoadHosPendingStatus();
    // this.LoadHosTrialStatus();
  }

  tabChanged(event: any) {
    this.selectedTab = event.index;
  }

  private LoadHosActiveStatus() { 
    this.loaderService.show();

    this.practiceService
      .GetAllHealthOrganizationsCheckoutStatus(this.page, this.pageSize, 1)
      .subscribe(
        (hosPage) => {
          this.filteredHosActive = this.sortById(hosPage.pageItems);
          this.totalRecordsActive = hosPage.totalRecords;
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }


  // Trail Tab
  private LoadHosTrialStatus() {
    this.loaderService.show();
    this.practiceService
      .GetAllHealthOrganizationsCheckoutStatus(this.page, this.pageSize, 1, false)
      .subscribe(
        (thosPage) => {
          const data = this.sortById(thosPage.pageItems);
          this.filteredHosTrial = data;
          this.totalRecordsTrial = thosPage.totalRecords;
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }

  // Active Tab
  private LoadHosInactiveStatus() {
    this.loaderService.show();
    // Trial end
    this.practiceService
      .GetAllHealthOrganizationsCheckoutStatus(this.page, this.pageSize, 0)
      .subscribe(
        (hosPage) => {
          this.filteredHosInActive = this.sortById(hosPage.pageItems);
          this.totalRecordsInactive = hosPage.totalRecords;
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }

  //Pending Tab
  private LoadHosPendingStatus() {
    this.loaderService.show();
    this.practiceService
      .getAllOrganizationRegistrations(this.page, this.pageSize)
      .subscribe(
        (hosPage) => {
          this.filteredHosPending = this.hosPending = this.sortById(hosPage.pageItems);
          this.totalRecordsPending = hosPage.totalRecords;
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }

  changeIndex(event: PageEvent, action: string) {
    this.pageSize = event.pageSize;
    this.page = event.pageIndex + 1;
    if (action === 'pending') {
      this.LoadHosPendingStatus();
    } else if (action === 'trial') {
      this.LoadHosTrialStatus();
    } else if (action === 'active') {
      this.LoadHosActiveStatus();
    } else {
      this.LoadHosInactiveStatus();
    }
  }

  filterBySearchText(searchText: string) {
    this.filteredHosPending = this.hosPending.filter((x: any) => x.name.toLowerCase().includes(searchText.toLowerCase()));
  }

  filterBySelectedOrg(orgId: number) {
    if (orgId === 0) {
      this.filteredHosPending = this.hosPending;
    } else {
      this.filteredHosPending = this.hosPending.filter((x: any) => x.healthOrganizationType === orgId);
    }
  }

  addEvent(hoID: number, event: MatDatepickerInputEvent<Date>) {
    this.notificationService
      .confirmation(
        "Updating End Of Trial Date",
        "Are you sure that you want to update the End of Trial Date?",
        "No",
        "Yes"
      )
      .subscribe((_) =>
        this.loaderService
          .blockWithLoader(
            this.practiceService.updateEndOfTrialDate(hoID, event.value)
          )
          .subscribe((r) => {
            this.LoadHosTrialStatus();
            this._matSnackBar.open("Updated to: " + r.result);
          })
      );
  }
  updateEndOfTrialDate(hoId: number, newEndOFTrialDate: Date) { }

  toggleEditSidebar(id: number) {
    this.selectedHealthOrgId = id;
    this.toggleSidebar = !this.toggleSidebar;
  }

  approveRegistration(row?: any) {
    this.loaderService.show();
    this.healthSystemService.ApproveHealthOrgHealthOrganization(row.id).subscribe(
      (result) => {
        console.log(result)
        if (result && result.isSuccess) {
          this.LoadHosPendingStatus();
          this.LoadHosActiveStatus();
        }
        return null;
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  rejectRegistration(row?: any) {
    this.loaderService.show();
    this.healthSystemService.RejectNewHealthOrgRequest(row.id).subscribe(
      (result) => {
        if (result && result.isSuccess) {
          this.LoadHosPendingStatus();
        }
        return null;
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  handleOnClick(row?: any) {
    this.healthSystemService.DeactiveHealthOrg(row.id).subscribe(
      (result) => {
        if (result && result.isSuccess) {
          this.LoadHosActiveStatus();
          this.LoadHosTrialStatus();
        }
        return null;
      },
      (error) => {
        return error;
      }
    );
  }

  sortById(data: any) {
    return data.sort(function (a, b) {
      return -(a.id - b.id);
    });
  }

  openWebsiteLink(link: string) {
    let hyperLink = '';
    if (link.includes('http')) {
      hyperLink = link;
    } else {
      hyperLink = `https://${link}`;
    }
    window.open(hyperLink, '_blank');
  }

  getHealthOrganizationName(id: number) {
    return id ? HEALTH_ORGANIZATION_TYPES.filter(x => x.id === id)[0].name : '';
  }
}
